import { useEffect, useRef } from 'react';

export function useCloseModalListener(states) {
  // Use a ref so the effect doesn't re-run when the array reference changes
  const statesRef = useRef(states);
  statesRef.current = states;

  useEffect(() => {
    const handleCloseModal = () => {
      const current = statesRef.current;
      (Array.isArray(current) ? current : [current])
        .filter((setState) => typeof setState === 'function')
        .forEach((setState) => setState(false));
    };

    document.addEventListener('closeModal', handleCloseModal);

    return () => {
      document.removeEventListener('closeModal', handleCloseModal);
    };
  }, []);
}
